
import OpToken from "./OpToken";
import SearchParsingError from "../errors/SearchParsingError";

const logSvc = new WeakMap();

class NearOpToken extends OpToken {
    constructor($log, maxDistance, isOrdered) {
        super($log, "near");

        //if $log not valid, then super call would have failed.
        logSvc.set(this, $log);

        this._tokenParams = {
            opType: "near",
            nearDistance: maxDistance,
            nearOrdered: isOrdered
        };

    }

    /*override*/
    toString() {
        let distanceVal = "Distance:" + (this._tokenParams.nearDistance == null ? "MAX": String(this._tokenParams.nearDistance));
        let orderedVal = "Ordered:" + (this._tokenParams.nearOrdered === true ? "true" : "false" );
        return `NearToken (${distanceVal}/${orderedVal})`;
    }

    /* override */
    toSearchRequest(childRequests) {
        let childTerms = childRequests.map(function(cRequest) {
            if ((angular.isUndefined(cRequest)) || (cRequest == null)) {
                throw new SearchParsingError("Proximity search connector requires exactly two keywords.");
            }

            if (cRequest.operation === "value") {
                return cRequest.value;
            }
            else {
                logSvc.get(this).error("Invalid Syntax: Found non-value token child of near op token.");
                throw new SearchParsingError("AND, OR, and AND NOT cannot be used inside a proximity search. Use parentheses to isolate the proximity search if necessary.");
            }
        }).filter(function(cVal) {
            return (cVal != null);
        });

        if (childTerms.length < 2) {
            throw new SearchParsingError("Proximity search doesn't have enough search terms: exactly 2 required.");
        }

        let nearRequest = {
            operation: this._tokenParams.opType,
            search_terms: childTerms,
            require_term_order: (this._tokenParams.nearOrdered === true)
        };

        if (Number.isInteger(this._tokenParams.nearDistance)) {
            nearRequest["term_distance"] = this._tokenParams.nearDistance;
        }

        return nearRequest;
    }
}

export default NearOpToken;




//////////////////
// WEBPACK FOOTER
// ./src/models/parser-tokens/NearOpToken.js
// module id = Q++F
// module chunks = 1